import {LinkProps, Link as RouterLink} from '@aboutyou/router';
import React, {forwardRef} from 'react';
import {AriaButtonLinkType} from '../../../types/AriaButtonLink';

export const BaseUnstyledLink = forwardRef<
  HTMLAnchorElement,
  LinkProps & AriaButtonLinkType
>(function Link(props, ref) {
  return <RouterLink {...props} ref={ref} />;
});
